import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgEghtesatNovin = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill='#5B2281' clipPath='url(#eghtesat_novin_svg__a)'>
      <path
        fillRule='evenodd'
        d='M4.163 8.656a4.05 4.05 0 0 0 2.312-.73 4.3 4.3 0 0 0 1.532-1.943c.315-.79.397-1.66.236-2.5a4.4 4.4 0 0 0-1.14-2.215A4.1 4.1 0 0 0 4.974.084a4 4 0 0 0-2.404.247c-.76.327-1.41.882-1.868 1.593a4.477 4.477 0 0 0-.384 4.06c.21.526.516 1.003.902 1.405.387.402.846.72 1.351.938s1.047.329 1.593.329'
        clipRule='evenodd'
      />
      <path d='M22.044 23.342c1.95-1.267 2.541-3.937 1.322-5.963s-3.786-2.642-5.735-1.375-2.54 3.937-1.322 5.964c1.219 2.026 3.787 2.641 5.735 1.374' />
      <path
        fillRule='evenodd'
        d='M11.98 23.87h.255L23.712.273H16.8zM7.784 23.87h3.498L16.102.273h-3.473zM.253 23.87h6.832L11.931.273h-.201z'
        clipRule='evenodd'
      />
    </g>
    <defs>
      <clipPath id='eghtesat_novin_svg__a'>
        <path fill='#fff' d='M0 .001h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgEghtesatNovin)
export default ForwardRef
